import React from 'react';
import { Button } from './ui/button';
import { BookOpen, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToBooks = () => {
    document.getElementById('books-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-orange-500 via-orange-400 to-white">
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-30 animate-blob"></div>
        <div className="absolute top-40 right-10 w-96 h-96 bg-black rounded-full mix-blend-overlay filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-20 left-1/2 w-80 h-80 bg-orange-300 rounded-full mix-blend-overlay filter blur-3xl opacity-40 animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full mb-8 shadow-lg">
          <Sparkles className="h-5 w-5 text-orange-500" />
          <span className="text-sm font-semibold text-gray-800 tracking-wide">
            WORD SEARCH PUZZLE BOOKS
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight drop-shadow-2xl">
          RCJ Puzzle Books
          <br />
          <span className="text-gray-900">Making Focus Fun</span>
        </h1>

        <p className="text-xl md:text-2xl text-white font-medium mb-12 max-w-3xl mx-auto leading-relaxed drop-shadow-lg">
          Sharpen your mind with our collection of fun and challenging word search puzzle books. 
          Perfect for all ages and skill levels!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={scrollToBooks}
            size="lg"
            className="bg-gray-900 hover:bg-black text-white font-bold px-10 py-7 text-lg rounded-full shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-orange-500/50"
          >
            <BookOpen className="mr-2 h-6 w-6" />
            Explore Books
          </Button>
          
          <Button
            onClick={() => document.getElementById('newsletter')?.scrollIntoView({ behavior: 'smooth' })}
            size="lg"
            variant="outline"
            className="bg-white/90 backdrop-blur-sm border-2 border-gray-900 text-gray-900 hover:bg-white font-bold px-10 py-7 text-lg rounded-full shadow-xl transition-all duration-300 hover:scale-105"
          >
            Join Our Newsletter
          </Button>
        </div>

        <div className="mt-16 flex flex-wrap justify-center gap-8 text-white">
          <div className="text-center">
            <div className="text-4xl font-black mb-2">4</div>
            <div className="text-sm font-medium opacity-90">Books Available</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-black mb-2">50+</div>
            <div className="text-sm font-medium opacity-90">Puzzles Per Book</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-black mb-2">110</div>
            <div className="text-sm font-medium opacity-90">Pages Each</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
